var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5C3.5 4.44772 3.94772 4 4.5 4H20.5C21.0523 4 21.5 4.44772 21.5 5C21.5 5.55228 21.0523 6 20.5 6H4.5C3.94772 6 3.5 5.55228 3.5 5ZM3.5 20C3.5 19.4477 3.94772 19 4.5 19H20.5C21.0523 19 21.5 19.4477 21.5 20C21.5 20.5523 21.0523 21 20.5 21H4.5C3.94772 21 3.5 20.5523 3.5 20ZM11.5 15C11.5 14.4477 11.9477 14 12.5 14H20.5C21.0523 14 21.5 14.4477 21.5 15C21.5 15.5523 21.0523 16 20.5 16H12.5C11.9477 16 11.5 15.5523 11.5 15ZM11.5 10C11.5 9.44772 11.9477 9 12.5 9H20.5C21.0523 9 21.5 9.44772 21.5 10C21.5 10.5523 21.0523 11 20.5 11H12.5C11.9477 11 11.5 10.5523 11.5 10ZM6.94094 12.0108C7.23691 12.2698 7.23691 12.7302 6.94094 12.9892L4.57803 15.0567C4.15775 15.4245 3.5 15.126 3.5 14.5676V10.4324C3.5 9.874 4.15775 9.57553 4.57803 9.94327L6.94094 12.0108Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndentRight);
export default __webpack_public_path__ + "static/media/IndentRight.21c9299232dac1e205678936ee845db3.svg";
export { ForwardRef as ReactComponent };